var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsOptional, IsString, IsUUID, Min } from "class-validator";
export class TokenUsageDTO {
}
__decorate([
    Expose(),
    Min(0),
    __metadata("design:type", Number)
], TokenUsageDTO.prototype, "input", void 0);
__decorate([
    Expose(),
    Min(0),
    __metadata("design:type", Number)
], TokenUsageDTO.prototype, "cached", void 0);
__decorate([
    Expose(),
    Min(0),
    __metadata("design:type", Number)
], TokenUsageDTO.prototype, "output", void 0);
// TODO: remove `isOptional` when all agents have been updated to call this endpoint with the new DTO
export class ReportConversationDTO {
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], ReportConversationDTO.prototype, "externalId", void 0);
__decorate([
    Expose(),
    Min(0),
    __metadata("design:type", Number)
], ReportConversationDTO.prototype, "length", void 0);
__decorate([
    Expose(),
    Type(() => TokenUsageDTO),
    __metadata("design:type", TokenUsageDTO)
], ReportConversationDTO.prototype, "audio", void 0);
__decorate([
    Expose(),
    Type(() => TokenUsageDTO),
    __metadata("design:type", TokenUsageDTO)
], ReportConversationDTO.prototype, "text", void 0);
__decorate([
    Expose(),
    IsOptional(),
    Min(0),
    __metadata("design:type", Number)
], ReportConversationDTO.prototype, "totalCosts", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ReportConversationDTO.prototype, "agentVersion", void 0);
__decorate([
    Expose(),
    IsOptional(),
    Min(0),
    __metadata("design:type", Number)
], ReportConversationDTO.prototype, "eventCount", void 0);
__decorate([
    Expose(),
    IsOptional(),
    Min(0),
    __metadata("design:type", Number)
], ReportConversationDTO.prototype, "userInteractionCount", void 0);
//# sourceMappingURL=report-conversation.dto.js.map